import { Input } from "@/components/ui/input";

/**
 * Uncontrolled password field so React does not write the secret into the
 * HTML `value=""` attribute (visible in Inspect). The live input still holds
 * the typed/autofilled password until submit; read it from the form.
 */
export default function LoginPasswordInput({ testId, className, autoComplete = "current-password", ...rest }) {
  return (
    <Input
      required
      type="password"
      name="password"
      autoComplete={autoComplete}
      autoCorrect="off"
      autoCapitalize="off"
      spellCheck={false}
      data-testid={testId}
      className={className}
      {...rest}
    />
  );
}

export function passwordFromForm(form) {
  if (!form) return "";
  const fd = new FormData(form);
  return String(fd.get("password") || "");
}
